<template>
	<Modal
		v-if="showModal && isAuthenticated()"
		:allow-close="true"
		:max-width="'max-w-[540px]'"
		@modal:close="closeModal"
	>
		<template #body>
			<div class="absolute top-4 left-4 text-[14px] leading-[20px] font-bold text-won-maroon">
				Limited Spots!
			</div>

			<div class="flex flex-col items-center gap-8 pb-2 font-[Inter]!">
				<div>
					<img :src="WonImage" />
				</div>

				<div class="text-won-blue">
					<h2 class="text-center text-[30px] leading-[36px] font-bold">
						Join our FREE Land Your Dream Job Webinar
					</h2>
                
					<div class="mt-8 text-[14px] leading-[20px] text-won-blue">
						<span class="font-bold">
							Learn how to:
						</span>

						<ul class="mt-4 list-inside list-disc pl-2">
							<li>Create the best resume structure to stand out to recruiters</li>
							<li>Craft the perfect resume bullets to show your skills & experiences</li>
							<li>Network with professionals to land interviews in 30 days</li>
						</ul>
					</div>

				</div>
			</div>
		</template>

		<template #actions>
			<div class="flex w-full items-center gap-8">
				<a
					href="https://event.webinarjam.com/channel/wonsultingwebinar"
					target="_blank"
					class="w-full"
				>
					<button
						class="w-full rounded bg-won-green py-[9.5px] text-base text-white"
					>
						Register Now
					</button>
				</a>

				<button
					class="w-full rounded border border-won-green p-[9.5px] text-base text-won-green"
					type="button"
					@click="closeModal"
				>
					Close
				</button>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { setAuthState } from '../composables/auth';
import Modal from '../components/modal.vue';

const WonImage = '/img/won.webp';

const { isAuthenticated } = setAuthState();

defineProps({
	showModal: {
		type: Boolean,
		default: false
	},
	closeModal: {
		type: Function,
		default: () => {}
	}
});
</script>
